(function() {
	'use strict';

	window.addEventListener('load', function() {

		var form = $('#pwd-form')[0];
		form.addEventListener('submit', function(event) {
			event.preventDefault();
			event.stopPropagation();

			if (form.checkValidity() === false) {

				// Form is not valid so show errors
				var wall = $('#pwd-err-msg').empty();

				// Remove old error messages
				wall.find("p").remove();

				// add new ones
				$.each($(':invalid'), function(index, error) {
					if ($(error).data('message')) {
						wall.append("<p>" + $(error).data('message') + "</p>");
					}
				});

				$('#pwd-err').show();


			} else {
				// Form is valid so hide errors and submit
				$('#pwd-err').hide();
				$('#pwd-wait').show();

				$.ajax({
					 type: "POST",
					 url: $(form).attr('action'),
					 data: $(form).serialize(), // serializes the form's elements.
					 dataType  : 'json',
					 xhrFields: { withCredentials: true },
					 encode  : true
				})
				.done(function(data) {
					$('#pwd-wait').hide();
					if (! data.success) {
						$('#pwd-err').show();
						$('#pwd-err-msg').html(data.error_msg);
					} else {
						$('#pwd-form').hide();
						console.log(data);
						$('#pwd-success-msg').html(data.msg);
						$('#pwd-success').show();
					}
				})
				.fail(function(XMLHttpRequest, textStatus, errorThrown) {
					console.log(XMLHttpRequest);
					console.log(textStatus);
					console.log(errorThrown);
					$('#pwd-wait').hide();
					$('#pwd-err-msg').text(textStatus + ' ' + errorThrown);
					$('#pwd-err').show();
				});

			}
			form.classList.add('was-validated');
		}, false);
	}, false);
})();